import { TextElement } from "../../base/Text/TextElement";

export default class CompareValuesItemLabel extends TextElement {
}
